<template>
  <NuxtLink
    :to="$localePath(`/categories`)"
    class="link flex flex-col justify-center items-center p-2 relative"
  >
    <div class="flex justify-center relative">
      <CatalogLinkActiveIcon v-if="isActive" />
      <CatalogLinkIcon
        v-else
        :class="[
          'inactive',
          { 'hidden': $route.path.includes('/catalog') || $route.path.includes('/categories') }
        ]"
      />
    </div>
    <div
      class="text-xs pt-0.5 text-center md:text-xxs"
      :class="{ 'text-black font-medium': isActive }"
    >
      Каталог
    </div>
  </NuxtLink>
</template>

<script>
import CatalogLinkActiveIcon from '~/assets/svg/header/catalog-active.svg?component'
import CatalogLinkIcon from '~/assets/svg/header/catalog.svg?component'

export default {
  components: {
    CatalogLinkIcon,
    CatalogLinkActiveIcon,
  },

  computed: {
    isActive () {
      return (
        this.$route.path.includes('/catalog') ||
          this.$route.path.includes('/categories')
      )
    },
  },
}
</script>
